import { SHIRTSPACE_OFFICE_ADDRESS, SHIRTSPACE_PHONE } from "~/constants";
import { formatPhoneNumber } from "~/utils/text";

const AddressPhone: React.FC = () => (
  <menu className="flex flex-col gap-y-1 md:w-1/2 lg:mb-8 lg:w-full">
    <li className="text-center">
      <a
        className="text-3xl text-blue hover:text-blue500"
        href={`tel:${SHIRTSPACE_PHONE}`}
      >
        {formatPhoneNumber(SHIRTSPACE_PHONE)}
      </a>
    </li>
    <li className="text-nowrap text-center text-black100">
      Mon–Fri, 6:30 AM–4:00 PM PST
    </li>
    <li className="text-nowrap text-center text-black100">
      {SHIRTSPACE_OFFICE_ADDRESS.join(" ")}
    </li>
  </menu>
);

export default AddressPhone;
